import * as React from 'react';
import styled from '@emotion/styled';
import { useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 3rem;
  flex: 1;
`;

const LoginPage = () => {
  const location = useLocation();
  const { logout, loginWithRedirect } = useAuth0();

  if (location.search.includes('error')) {
    logout({
      returnTo: `${window.location.origin}`,
    });
  }

  if (!location.search) {
    loginWithRedirect();
  }

  return (
    <StyledContainer>
      <h2>Loading... </h2>
    </StyledContainer>
  );
};
export default LoginPage;
